import { popoverBaseStyle, popoverArrow } from './styles';
import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import * as meta from '../../meta-data.json';
import { borderColor, borderStyle, borderWidth, marginSize } from '../../Utilities/utils/Theming';

export const overrides = (props: any) => {
	const {
		accessibilityType,
		focusLock,
		autoFocus,
		returnFocus,
		ignoreBoundary,
		onMouseEnterDelay,
		onMouseLeaveDelay,
		placement,
		showArrow,
		triggerType,
		mountNode,
		animateOutTime,
		popperOptions,
		renderAll,
		children,
		content,
		overrides = {},
		isOpen,
		onClickOutside,
		initialState,
		dismissOnEsc,
		dismissOnClickOutside,
		onEsc,
		onClick,
		inverted,
		...rest
	} = props;

	return {
		Body: {
			style: {
				boxShadow: "none",
				...borderColor(props.inverted ? "var(--epods--color-border-light)" : "none"),
				...borderWidth(props.inverted ? "var(--epods--border-width)" : "0px"),
				borderStyle: 'solid', //...borderStyle(props.inverted ? "solid" : "none"),
			},
			props: {
				'data-epo': `epo-popover-${meta.version}`,
				part: `epo-popover-${meta.version}`,
				...rest,
			},
		},
		Inner: {
			props: {
				...getBaseCustomProps(props),
				$as: 'div',
			},
			style: ({ $theme }: any) => {
				return {
					...popoverBaseStyle(props),
				};
			},
		},
		Arrow: {
			style: ({ $theme }: any) => {
				return {
					...popoverArrow(props),
					...borderColor(props.inverted ? "var(--epods--color-border-light)" : "none"),
					...borderWidth(props.inverted ? "var(--epods--border-width)" : "0px"),
					borderStyle: "solid", //...borderStyle(props.inverted ? "solid" : "none"),
				};
			},
		},
	};
};
